import type { FluxErrorEntityErrorCodes } from '../types.js';

export const PermissionErrorCodes = {
  PermissionNotFound: {
    code: 'permission/not-found',
    explanation: 'A permissão que você está tentando acessar não foi encontrada.',
    localizations: {},
    message: 'Permissão não encontrada.',
  },
} as const satisfies FluxErrorEntityErrorCodes<'permission'>;
